import { render, staticRenderFns } from "./BlogsSingle.vue?vue&type=template&id=d316e21a"
import script from "./BlogsSingle.vue?vue&type=script&lang=js"
export * from "./BlogsSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports